import { render, staticRenderFns } from "./ForumPost.vue?vue&type=template&id=38a20cd2&scoped=true"
import script from "./ForumPost.vue?vue&type=script&lang=js"
export * from "./ForumPost.vue?vue&type=script&lang=js"
import style0 from "./ForumPost.vue?vue&type=style&index=0&id=38a20cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a20cd2",
  null
  
)

export default component.exports